import { Item } from '@factorialco/deprecated-design-system'

import DropdownSearchBar from 'modules/core/components/DropdownSearchBar'
import i18n from 'modules/core/lib/i18n'

interface OptionDropdownProps {
  name: string
  selectedValue: string
  options: Item[]
  onSelect: (value: string, label: string) => void
  loading?: boolean
}

export const OptionDropdown = ({
  selectedValue,
  options,
  onSelect,
  loading = false,
}: OptionDropdownProps) => (
  <DropdownSearchBar
    name={selectedValue}
    placeholder={i18n.t('common.none')}
    label=""
    onSelect={(value) => onSelect(value['value'].toString(), value['label'])}
    labelNotFound={i18n.t('common.none')}
    data={options}
    searchLabel={i18n.t('common.search')}
    autofocus={false}
    ellipsis={false}
    loading={loading}
  />
)
